<template>
  <div class="choose-bonus">
    <div class="choose-bonus-heading heading-snaps" v-if="selected === 'snaps'">Snaps Selected</div>
    <div
      class="choose-bonus-heading heading-credit"
      v-else-if="selected === 'credit'"
    >Discount Selected</div>
    <div class="choose-bonus-heading" v-else>Choose Your Bonus</div>

    <div class="reward">
      <div
        class="reward-option reward-option-snaps"
        :class="{'reward-selected': selected === 'snaps'}"
        @click="selectOption('snaps')"
      >
        <img src="/images/icons/snap.svg" class="snaps-icon" />
        <div class="points">{{ assignment.listing_price * 300 | bigNumber }} snaps</div>
      </div>
      <div
        class="reward-option reward-option-credit"
        :class="{'reward-selected': selected === 'credit'}"
        @click="selectOption('credit')"
      >
        <div class="credit">${{ (assignment.listing_price * 1.50) | shortDollars }} off this month</div>
      </div>
    </div>

    <div class="choose-bonus-more" v-if="!selected">
      Books requiring a purchase give you a bonus of either
      <span class="snaps-bonus-text">300 snaps</span>
      or
      <span class="credit-bonus-text">$1.50 off</span>
      <br />your membership this month for
      <span class="blue-bonus-text">every $1</span> that the book costs.
    </div>
  </div>
</template>

<script>
export default {
  name: "ChooseYourBonus",
  props: ["assignment", "selected", "onSelect"],
  data: function() {
    return {};
  },
  methods: {
    async selectOption(value) {
      this.onSelect(value);
    }
  }
};
</script>

<style lang="scss" scoped>
.choose-bonus {
  margin: 0 0 0px 0;
}

.choose-bonus-heading {
  font-size: 12pt;
  color: $color-blue;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-weight: 700;
}
.choose-bonus-more {
  font-size: 11.5pt;
}
.strong {
  font-weight: 700;
  color: #444;
}

.reward {
  display: flex;
  justify-content: center;
  padding: 0px;
}
.reward-label {
  color: $color-blue;
  font-size: 15pt;
  font-weight: 700;
  padding: 0.5em 0.75em;
}
.reward-option {
  display: flex;
  align-content: center;
  justify-content: center;
  width: 218px;
  margin: 20px 8px;
  margin-top: 16px;
  padding: 16px 20px;
  border: 2px solid #eee;
  border-radius: 8px;
  font-size: 13pt;
  font-weight: 500;
}
.reward-option:hover {
  background: #fff;
  border: 2px solid #ddd;
  cursor: pointer;
}
.reward-option-snaps.reward-selected {
  border: 2px solid lighten($color-snaps, 25%);
}
.reward-option-credit.reward-selected {
  border: 2px solid lighten(#4caf50, 25%);
}
.reward-selected {
  border: 2px solid #e3e3e3;
  box-shadow: 0 0 0.5rem rgba(0, 0, 0, 0.1);
}
.reward-summary {
  padding-bottom: 60px;
  text-align: center;
  font-size: 12.5pt;
  color: #111;
}

.heading-snaps {
  color: darken($color-snaps, 0%) !important;
}
.heading-credit {
  color: #4caf50 !important;
}

.snaps-icon {
  float: left;
  width: 24px;
  margin: 3px 2px 0 0px;
}
.points-icon {
  float: left;
  color: $color-snaps;
  font-size: 18pt !important;
}
.points {
  float: left;
  margin-top: -0px;
  padding-top: 0px !important;
  color: darken($color-snaps, 0%);
  margin-left: 5px;
  font-size: 14.5pt !important;
  font-weight: 600;
  font-family: "Source Sans Pro";
}
.credit {
  float: left;
  margin-top: -0px;
  padding-top: 0px !important;
  color: #4caf50;
  margin-left: 5px;
  font-size: 14.5pt !important;
  font-weight: 600;
  font-family: "Source Sans Pro";
}

.credit-bonus-text {
  color: darken(#4caf50, 5%);
  font-weight: 600;
}
.snaps-bonus-text {
  color: darken($color-snaps, 0%);
  font-weight: 600;
}
.blue-bonus-text {
  color: $color-blue;
  font-weight: 600;
}

@media (max-width: 480px) {
  .reward-option {
    padding-left: 0px !important;
    padding-right: 0px !important;

    .points,
    .credit {
      font-size: 13.5pt !important;
    }
  }
}
</style>
